export const baseUrl= 'https://api.themoviedb.org/3/';
export const API_KEY='fc9324935a273b768eaf7ed8ca8c4444';
export const backdropimgURL="https://image.tmdb.org/t/p/original"
